import { userObsoleteApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const MANAGED_USERS_ACTIONS = createNamedActions('managedUsers', {
  GET_USERS: 'GET_USERS',
});

export const getUserManagedIdsAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await userObsoleteApi.getManageableIds();

  return dispatch({
    type: MANAGED_USERS_ACTIONS.GET_USERS,
    payload: data,
  });
});
